import React from "react";
import styles from "./index.module.scss";

interface SelectItemProps {
  title: string;
  selected: boolean;
  distance?: number;
  address?: string;
  highlightText?: string;
  onClick?: () => void;
}

const SelectItem: React.FC<SelectItemProps> = ({
  title,
  selected,
  distance,
  address,
  highlightText,
  onClick,
}) => {
  // 高亮文本处理（支持多个匹配）
  const renderTitle = () => {
    if (!highlightText || !title.includes(highlightText)) {
      return title;
    }

    // 使用正则表达式全局匹配所有出现的高亮文本
    const regex = new RegExp(
      `(${highlightText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`,
      "gi",
    );
    const parts = title.split(regex);

    return (
      <React.Fragment>
        {parts.map((part, index) => {
          // 判断是否是匹配的文本（忽略大小写）
          if (part.toLowerCase() === highlightText.toLowerCase()) {
            return (
              <span key={index} className={styles.highlight}>
                {part}
              </span>
            );
          }
          return <React.Fragment key={index}>{part}</React.Fragment>;
        })}
      </React.Fragment>
    );
  };

  return (
    <div className={styles.selectItem} onClick={onClick}>
      <div className={styles.content}>
        <div className={`${styles.title} ${selected ? styles.selected : ""}`}>
          {renderTitle()}
        </div>
        {(distance !== undefined || address) && (
          <div className={styles.meta}>
            {distance !== undefined && (
              <span className={styles.distance}>直线距离{distance >= 1000 ? `${(distance / 1000).toFixed(2)}km` : `${distance}m`}</span>
            )}
            {distance !== undefined && address && (
              <div className={styles.divider} />
            )}
            {address && <span className={styles.address}>{address}</span>}
          </div>
        )}
      </div>
      <div className={styles.iconWrapper}>
        {selected && <div className={styles.icon} />}
      </div>
    </div>
  );
};

export default SelectItem;
